Object.defineProperty(exports, "__esModule", { value: true });
exports.UserNotificationType = void 0;
var UserNotificationType;
(function (UserNotificationType) {
    UserNotificationType["AskDataSharing"] = "ask-data-sharing";
    UserNotificationType["Commenting"] = "commenting_mention";
    UserNotificationType["CreateExtractFailure"] = "ExtractCreationFailed";
    UserNotificationType["ExplainDataSharing"] = "explain-data-sharing";
    UserNotificationType["FlowCompleted"] = "FlowCompleted";
    UserNotificationType["FlowFailed"] = "FlowFailed";
    UserNotificationType["RefreshExtractFailure"] = "ExtractRefreshFailed";
    UserNotificationType["RefreshExtractSuspension"] = "ExtractRefreshSuspended";
    UserNotificationType["Sharing"] = "sharing";
    UserNotificationType["CreateExtractSucceededV2"] = "ExtractCreationSucceededV2";
    UserNotificationType["CreateExtractFailedV2"] = "ExtractCreationFailedV2";
    UserNotificationType["CreateExtractCanceledV2"] = "ExtractCreationCanceledV2";
    UserNotificationType["AutoSuspension"] = "auto-suspension";
    UserNotificationType["PredictiveModelTrainingSuccess"] = "ModelTrainingSuccess";
    UserNotificationType["PredictiveModelTrainingFail"] = "ModelTrainingFail";
})(UserNotificationType = exports.UserNotificationType || (exports.UserNotificationType = {}));
//# sourceMappingURL=UserNotificationType.js.map